import {Route, Routes} from 'react-router-dom';
import {AccountInfo} from './thong-tin';

export const Account = () =>{
  return (
    <Routes>
      <Route path="thong-tin" element={<AccountInfo/>}></Route>
    </Routes>
  )
}